import {Component, OnInit} from '@angular/core';
import {HelperProvider} from '../providers/helper.provider';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'SatinAlma-Client';

  constructor(private helperProvider: HelperProvider) {
  }

  ngOnInit(): void {
    this.helperProvider.loading$.next(true);
  }


}
